namespace Ir.Components.Mapping.MappingTreePopover {    
    export interface IMappingPopover {
        show(options: IMappingPopoverOptions);
        hide();
        getInstance(): DevExpress.ui.dxPopover;
    }

    export interface IMappingPopoverOptions {
        type: MappingPopoverTypeEnum;
        $target,
        onSelect: (item) => void;
        onSelectTable?: (fields: Array<FieldNameInputModel>) => void;
        title?: string;
        onFiltering?: (items: Array<TableNameInputModel | FilterTemplate>) => Array<TableNameInputModel | FilterTemplate>;
        fieldDragTemplate?: (e, selectedItem) => JQuery<HTMLElement>;
        keepItOpened?: boolean;
        useOriginalName?: boolean;
    }

    interface IViewModel {
        treeViewOptions: DevExpress.ui.dxTreeView.Properties;
        sortableOptions: DevExpress.ui.dxSortable.Properties;
        popoverOptions: DevExpress.ui.dxPopover.Properties;
        contextMenuOptions: DevExpress.ui.dxContextMenu.Properties;
    }

    export interface IMappingOptions {
        height: string | number;
        showButtonsInRow?: boolean;
        fieldTitle: KnockoutObservable<string>;
        addField: (item) => void;
        groupTitle: KnockoutObservable<string>;
        addGroup: (item) => void;
        metricTitle: KnockoutObservable<string>;
        addMetric: (item) => void;
    }
    interface IParams {
        callback(o: IMappingPopover);
        config?: IMappingOptions;
    }
    export function getViewModel(this: IViewModel, params: IParams, componentInfo) {
        let self = this;

        let popoverInstance: DevExpress.ui.dxPopover;
        let treeViewInstance: DevExpress.ui.dxTreeView;
        let contextMenuInstance: DevExpress.ui.dxContextMenu;
        let mappingItems = [];
        let lastType;
        let updateItems = true;
        let timeout;

        let selectedItem: KnockoutObservable<FieldNameInputModel> = ko.observable();
        let options: IMappingPopoverOptions;

        let selectedTreeItem = null;
        this.treeViewOptions = {
            width: "100%",
            height: "100%",
            keyExpr: "nodeId",
            itemTemplate(item) {
                let displayName = item.title || item.displayName || item.nodeName || item.name || item.tableName;
                if (options.useOriginalName) {
                    displayName = item.originalName
                }

                displayName = replaceBasicHtmlContent(displayName);

                if (params.config?.showButtonsInRow && ((item instanceof FieldNameInputModel && (item.fields === undefined || item.fields?.length === 0)) || item instanceof TableNameInputModel)) {
                    let showMetricButton = item instanceof FieldNameInputModel ? (item as FieldNameInputModel).metric : false;
                    let showFieldGroupButton = item instanceof FieldNameInputModel ? !(item as FieldNameInputModel).metric : false;
                    if (item instanceof TableNameInputModel) {
                        showMetricButton = false;
                        showFieldGroupButton = item.id !== -1;//-1 Metrics
                    }

                    let width = (showMetricButton ? 25 : 0) + (showFieldGroupButton ? 50 : 0)
                    let element = $(`<div class="treeView-item">
                <div class="treeView-item-label">${displayName}</div>
                <div style="width: ${width}px">
                    <div data-bind="dxButton: addMetricOptions"></div>
                    <div data-bind="dxButton: addFieldOptions"></div>
                    <div data-bind="dxButton: addGroupOptions"></div>
                </div>
                </div>`);
                    ko.applyBindings({
                        addMetricOptions: {
                            icon: "ms ir-add-field",
                            stylingMode: 'contained',
                            hint: `Add field to ${params.config.metricTitle()}`,
                            visible: showMetricButton,
                            height: 20,
                            width: 22,
                            onClick(e) {
                                params.config.addMetric(item);
                            }
                        },
                        addFieldOptions: {
                            icon: "ms ir-add-field",
                            hint: `Add field to ${params.config.fieldTitle()}`,
                            visible: showFieldGroupButton,
                            height: 20,
                            width: 22,
                            onClick(e) {
                                params.config.addField(item);
                            }
                        },
                        addGroupOptions: {
                            icon: "ms ir-add-group",
                            hint: `Add field to ${params.config.groupTitle()}`,
                            visible: showFieldGroupButton,
                            height: 20,
                            width: 22,
                            onClick(e) {
                                params.config.addGroup(item);
                            }
                        },
                    }, element.get(0));

                    return element;
                }

                return `<div>${displayName}</div>`;
            },
            itemsExpr: "fields",
            searchEnabled: true,
            searchExpr: ["title", "displayName", "nodeName", "name", "tableName"],
            searchMode: "contains",
            scrollDirection: "vertical",
            selectByClick: true,
            selectionMode: "single",
            useNativeScrolling: false,
            onInitialized: function (e) {
                treeViewInstance = e.component;
            },
            onItemClick: function (e) {
                var item = e.itemData;

                if (!timeout) {
                    timeout = setTimeout(function () {
                        timeout = null;
                    }, 300);
                }
                //only for fields (table doesn't have queryName)
                else {
                    if (item === self.treeViewOptions.selectedItem) {
                        if ((item instanceof FieldNameInputModel || item instanceof FilterTemplate)) {
                            options.onSelect?.(item);
                        }
                        else {
                            if (item instanceof TableNameInputModel) {
                                if (options.onSelectTable) {
                                    options.onSelectTable?.(item.visibleFields);
                                    e.event.preventDefault();
                                    e.event.stopPropagation();
                                }
                            }
                        }
                        if (!options.keepItOpened) {
                            popoverInstance.hide();
                        }
                    }
                }

                self.treeViewOptions.selectedItem = item;
            },
            onItemSelectionChanged(e) {
                selectedItem(e.itemData as any);
            },
            onItemContextMenu(e) {
                selectedTreeItem = e.itemData;

                let colExpVisible = (e.node as any).items?.length > 0;
                contextMenuInstance.option('items[1].visible', colExpVisible);
                contextMenuInstance.option('items[3].visible', colExpVisible);

                contextMenuInstance.show();
            },
        };

        this.contextMenuOptions = {
            dataSource: [
                { id: 'expandAll', text: 'Expand All' },
                { id: 'expand', text: 'Expand' },
                { id: 'collapseAll', text: 'Collapse All' },
                { id: 'collapse', text: 'Collapse' },
            ] as any,
            target: '#mappingFieldsTreeView .dx-treeview-item',
            onItemClick(e) {
                switch ((e.itemData as any).id ) {
                    case 'expand': {
                        treeViewInstance.expandItem(selectedTreeItem.nodeId);
                        break;
                    }
                    case 'collapse': {
                        treeViewInstance.collapseItem(selectedTreeItem.nodeId);
                        break;
                    }
                    case 'expandAll': {
                        treeViewInstance.expandAll();
                        break;
                    }
                    case 'collapseAll': {
                        treeViewInstance.collapseAll();
                        break;
                    }
                    default:
                        break;
                }
            },
            onInitialized(e) {
                contextMenuInstance = e.component;
            }
        };

        let sortableControl;
        this.sortableOptions = {
            group: "fields",
            filter: ".dx-treeview-item",
            data: { selectedItem },
            dropFeedbackMode: "indicate",
            moveItemOnDrop: false,
            allowDropInsideItem: false,
            allowReordering: false,
            height: "100%",
            onDragChange(e) {
                if (e.toComponent === sortableControl) {
                    e.cancel = true;
                }
            },
            onDragStart(e) {
                //if (params.config?.showButtonsInRow) {
                //    e.cancel = true;
                //    return;
                //}

                treeViewInstance.selectItem(e.itemElement);
                selectedItem(treeViewInstance.getSelectedNodes()[0].itemData as any);
                if (selectedItem() instanceof TableNameInputModel) {
                    e.cancel = true;
                }
            },
            onInitialized(e) {
                sortableControl = e.component;
            }
        };

        this.popoverOptions = {
            title: "Mapping Fields",
            showTitle: true,
            target: "#popoverTarget",
            position: "left",
            minHeight: 300,
            //maxHeight: params.config?.height ? undefined : 500,
            height: params.config?.height ? params.config.height : "80%",
            width: 300,
            hideOnOutsideClick: params.config?.showButtonsInRow ? false : true,
            toolbarItems: [{
                widget: "dxButton",
                location: "after",
                    options: {
                        icon: "ms ir-sort-by-alpha-icon",
                        hint: "Sort alphabetically",
                        elementAttr: {
                            class: `ir-sort-fields ${loggedUser.alphabeticalOrder ? "selected" : ""}`
                        },
                        onClick(e) {
                            loggedUser.alphabeticalOrder = !loggedUser.alphabeticalOrder;
                            if (e.element.hasClass("selected")) {
                                e.element.removeClass("selected");
                            }
                            else {
                                e.element.addClass("selected");
                            }

                            let treeDataSource = treeViewInstance.option("dataSource") as any;
                            treeDataSource.reload();
                        }
                    }
            }],
            onInitialized: function (e) {
                popoverInstance = e.component;
                if (params.callback) {
                    params.callback({
                        show(optionsParameter: IMappingPopoverOptions) {
                            options = optionsParameter;
                            popoverInstance.option("title", options.title ?? "Mapping Fields");

                            if (lastType !== optionsParameter.type) {
                                lastType = optionsParameter.type;
                                updateItems = true;
                                mappingItems = getDataSourcePopover(options.type);
                            }

                            if (optionsParameter.$target) {
                                popoverInstance.show(optionsParameter.$target);
                            }
                        },
                        hide() {
                            popoverInstance?.hide();
                        },
                        getInstance() : DevExpress.ui.dxPopover {
                            return popoverInstance;
                        }
                    } as IMappingPopover);
                }
            },
            onShowing(e) {
                if (updateItems || options.onFiltering) {
                    let items = mappingItems;
                    if (options.onFiltering) {
                        items = options.onFiltering(items.slice());
                    }

                    let store = new DevExpress.data.CustomStore({
                        load: () => {
                            let sorted = items.sort(MappingService.sortFields);
                            sorted.forEach(item => {
                                if (Array.isArray(item.fields)) {
                                    item.fields = item.fields.sort(MappingService.sortFields);
                                }
                            });

                            return sorted;
                        }
                    });

                    let treeDataSource = new DevExpress.data.DataSource({
                        store: store,
                    })
                    //treeViewInstance.option("items", items);
                    treeViewInstance.option("dataSource", treeDataSource);

                    sortableControl.option("dragTemplate", options.fieldDragTemplate ? function (e) { return options.fieldDragTemplate(e, selectedItem()); } : null);
                    updateItems = false;
                }
                if (options.type === MappingPopoverTypeEnum.Metrics) {
                    const mapping = MappingService.getCurrentMapping();
                    treeViewInstance.expandItem(mapping.visibleMetrics[0]);
                }
                else if (options.type === MappingPopoverTypeEnum.All || options.type === MappingPopoverTypeEnum.MetricsNode)
                    treeViewInstance.expandItem(mappingItems[0]);
            },
            onHidden(e) {
                treeViewInstance.resetOption("searchValue");
                treeViewInstance.collapseAll();
            }
        };
    }

    function getDataSourcePopover(type: MappingPopoverTypeEnum) {
        var items = [];
        const mapping = MappingService.getCurrentMapping();

        switch (type) {
            case MappingPopoverTypeEnum.Metrics:
                items = mapping.visibleMetrics;
                break;
            case MappingPopoverTypeEnum.NonMetrics:
                items = mapping.visibleTables.map(visibleTable => {
                    let newTable = visibleTable.clone();
                    newTable.fields = visibleTable.visibleFields;
                    return newTable;
                });  
                break;
            //Show only tables with date fields
            case MappingPopoverTypeEnum.Date:
            case MappingPopoverTypeEnum.DateNonDerivedDates:
                let visibleTables = mapping.visibleTables;
                for (var i = 0; i < visibleTables.length; i++) {
                    let table = visibleTables[i];
                    if (table.visibleFields.find(x => x.type === DataTypeEnum.DATE)) {
                        let newTable = new TableNameInputModel(table);
                        newTable.fields = [];
                        items.push(newTable);
                        for (let field of table.visibleFields) {
                            if (field.type === DataTypeEnum.DATE && field.visibility === VisibilityEnum.Normal) {
                                let newField = new FieldNameInputModel(field);
                                if (type === MappingPopoverTypeEnum.DateNonDerivedDates) {
                                    newField.fields = undefined;
                                }
                                newTable.fields.push(newField);
                            }
                        }
                    }
                }
                break;
            case MappingPopoverTypeEnum.NonMetricsNonDerivedDates:
                for (let table of mapping.visibleTables) {
                    let newTable = new TableNameInputModel(table);
                    newTable.fields = [];

                    let fields = table.visibleFields.filter(x => x.visibility === VisibilityEnum.Normal);
                    for (let field of fields) {
                        let newField = new FieldNameInputModel(field);

                        if (field.type === DataTypeEnum.DATE) {
                            newField.fields = null;
                        }
                        newTable.fields.push(newField);
                    }

                    if (newTable.fields.length > 0) {
                        items.push(newTable);
                    }
                }
                break;
            case MappingPopoverTypeEnum.NonMetricsNonDates:
                for (let table of mapping.visibleTables) {
                    if (table.visibleFields.find(x => x.type !== DataTypeEnum.DATE)) {
                        let newTable = new TableNameInputModel(table);
                        newTable.fields = [];
                        items.push(newTable);
                        for (let field of table.visibleFields) {
                            if (field.type !== DataTypeEnum.DATE && field.visibility === VisibilityEnum.Normal) {
                                newTable.fields.push(field);
                            }
                        }
                    }
                }
                break;
            case MappingPopoverTypeEnum.Filters:
                items = mapping.visibleFilters;
                break;
            case MappingPopoverTypeEnum.All:
            case MappingPopoverTypeEnum.AllNonDerivedDates:
            case MappingPopoverTypeEnum.MetricsNode:
            default:
                let newTable = new TableNameInputModel({
                    id: MappingService.metricTableId,
                    isPrincipal: false,
                    originalName: MappingService.metricTableName,
                    tableName: MappingService.metricTableName,
                    schemaField: true,
                    visibility: VisibilityEnum.Normal,
                    fields: mapping.visibleMetrics.map(obj => {
                        let newField = new FieldNameInputModel(obj);
                        newField.tableName = MappingService.metricTableName; // replace the table name for the search to work
                        return newField;
                    }),
                });
                if (type !== MappingPopoverTypeEnum.MetricsNode) {
                    let tables = mapping.visibleTables.map(visibleTable => {
                        let newTable = visibleTable.clone();

                        if (type === MappingPopoverTypeEnum.AllNonDerivedDates && newTable.visibleFields.find(x => x.type === DataTypeEnum.DATE)) {
                            newTable.fields = [];
                            for (let field of visibleTable.visibleFields) {
                                let newField = new FieldNameInputModel(field);
                                newField.autoGrouping = AutoGroupingEnum.None;
                                newTable.fields.push(newField);
                                if (field.type === DataTypeEnum.DATE && field.visibility === VisibilityEnum.Normal) {
                                    newField.fields = undefined;
                                }
                            }
                        }
                        else {
                            newTable.fields = visibleTable.visibleFields;
                        }

                        return newTable;
                    });

                    items = [newTable, ...tables];
                }
                else {
                    items = [newTable];
                }

                break;
        }

        return items;
    }
}